import AddMemberForm from 'components/hyperwolf/members/addMemberForm';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getMemberDetailsbyEmail } from '../../../../redux/slices/hyperwolf/members';

export default function AddMemberHyperwolf() {
  const dispatch = useDispatch();
  const { memberEmail = '' } = useParams();
  useEffect(() => {
    if(memberEmail){
      dispatch(getMemberDetailsbyEmail(memberEmail));
    }
  }, [memberEmail]);
  return (
    <CommonLayout>
      <AddMemberForm/>
    </CommonLayout>
  );
}
